import $ from 'jquery';
import { Router } from '@angular/router';
import {
  Component,
  OnDestroy,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { Session } from '../../services/session';
import { refreshPage } from '../../lib/utils';
import { TrialPreLoadingService } from './trial-pre-loader.service';
import { ISuccess, UPSELL_SUCCESS } from './upsell-config';

@Component({
  selector: 'trial-activated-modal',
  templateUrl: './trial-activated-modal.component.html',
  styleUrls: ['./trial-activated-modal.component.scss', '../../styles/upgrade.scss'],
})
export class TrialActivatedModalComponent implements AfterViewInit, OnDestroy {
  public $modal;
  public el;
  public upsellPreLoader: boolean;
  public successCopy: ISuccess;

  constructor(
    private trialPreLoaderStatus: TrialPreLoadingService,
    private session: Session,
    private router: Router,
    el: ElementRef,
  ) {
    this.el = el.nativeElement;
    this.successCopy = UPSELL_SUCCESS['default'];
  }

  public ngAfterViewInit(): void {
    this.$modal = $(this.el.querySelector('.ui.modal'));
  }

  public show(key): void {
    this.successCopy = UPSELL_SUCCESS[key ? key : 'default'];
    this.$modal.modal('show');
  }

  public ngOnDestroy(): void {
    this.hideModal();
    this.$modal.modal('destroy');
    this.$modal.remove();
  }

  public hideModal(): void {
    this.$modal.modal('hide');
  }

  public proTrialActivate(): void {
    this.trialPreLoaderStatus.setProTrialPreLoader(true);
    const currentUrl = this.router.url;
    const route = currentUrl.slice(0, currentUrl.lastIndexOf('/'));
    const NAVIGATE_TO_PAGE_TIME = 3000;

    setTimeout(() => {
      refreshPage(`${window.location.origin}/#` + route);
    }, NAVIGATE_TO_PAGE_TIME);
  }
}
